module.exports = __webpack_public_path__ + "static/mypic-fd6b0c631984f73b3e92ce652d795d3e.jpg";